var parts = ['container', 'dot', 'line']; // @TODO: Make configurable?

var DOT_SIZE = '10px';
var baseStyleLine = function baseStyleLine(props) {
  var c = props.colorScheme;
  return {
    top: '50%',
    left: DOT_SIZE,
    width: "calc(100% - ".concat(DOT_SIZE, ")"),
    height: '2px',
    transform: 'translateY(-50%) translateX(-1px)',
    bgColor: "gray.200",
    '&[data-current]': {
      bgColor: "".concat(c, ".400")
    },
    '&[data-last]': {
      bgGradient: "linear(to-r, ".concat(c, ".400, gray.200)")
    },
    transitionProperty: 'common',
    transitionDuration: 'normal'
  };
};
var baseStyleDot = function baseStyleDot(props) {
  var c = props.colorScheme;
  return {
    border: '2px',
    borderColor: 'gray.300',
    borderRadius: 'circle',
    bg: 'transparent',
    left: '-1px',
    boxSize: DOT_SIZE,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    '&[data-current]': {
      bg: "".concat(c, ".400"),
      borderColor: "".concat(c, ".400")
    }
  };
};
var baseStyle = function baseStyle(props) {
  return {
    container: {},
    line: baseStyleLine(props),
    dot: baseStyleDot(props)
  };
};
var defaultProps = {
  colorScheme: 'blue'
};
var StepIndicator = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { StepIndicator as default };